const divBody = document.querySelector('#filmConsider_card').querySelector('div[name=bodyFilmVideos]');

import auth from '../tools/storage.js';
import tools from '../tools/tools.js';


export default {

  cleanContainer() {
    divBody.innerHTML = '';
  },

  getElement(item, index, timezone, newLink) {

    let detailHTML = '';
    let enableCheckButton = false;

     let newVideoIcon = '';
    if (newLink)
      newVideoIcon = ` little-icon-newAttach `;


    return `<div class="reference-header  m-0 pl-1 "> 
            <div  class=" m-0 pl-1 w-60 ${newVideoIcon}"><a href="${item.url}"  target="_blank">${item.url}</a></div>
            <div  class=" m-0 pl-1  w-20"> ${item.password} </div>
            <div  class=" m-0 pr-1  w-20"> ${tools.dateStringFullAddTimeZone(item.date, timezone)} </div>
          </div>`;
  },

  drawDataInContainer(listWithData, notificationsVideo) {
    this.cleanContainer();
    let HTMLBODY = '';
    if(listWithData) {
      const date = new Date();
      const curTimeZone = (date.getTimezoneOffset())/60 * -1;

      HTMLBODY = `

          <label>Ссылка на оригиналы (new):</label>
          <div class="reference-header p-1 firstRow">
              <div class="pl-1 w-60">Ссылка</div>
              <div class="pl-1 w-20">Пароль</div>
              <div class="pr-1 w-20">Дата изменения</div>
          </div>
          `;
      listWithData.forEach((item, index) => {
        let newLink = false;
        if(notificationsVideo)
          notificationsVideo.forEach((newLinkID) => {
            if(parseInt(item.id) === parseInt(newLinkID)){
              console.log(newLink);
              newLink = true;
            }
          });
        HTMLBODY += this.getElement(item, index, curTimeZone, newLink);
      });

      divBody.innerHTML = HTMLBODY;
    }
  },


  drawMarkupInContainer(markup) {
    divBody.insertAdjacentHTML('beforeend', markup);
  },

};
